import styled from "styled-components";

// --- ActivityLogDrawer ---
export const DrawerOverlay = styled.div`
  position: fixed;
  left: 0;
  right: ${props => (props.$isOpen ? "0" : "-100%")};
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(1px);
  display: flex;
  justify-content: end;
  z-index: 9999;
  transition: right 0.3s ease-in-out;
`;

export const DrawerContent = styled.div`
  width: 540px;
  max-width: 100vw;
  background-color: #fff;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
`;

export const DrawerBody = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 16px 8px;
`;

// --- TimelineList ---
export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;

  color: #444;
  font-family: Inter;
  font-style: normal;
  line-height: normal;
`;

export const EmptyState = styled.div`
  padding: 32px 16px;
  text-align: center;
  color: #8c8ca1;
  font-size: 14px;
`;

// --- TimelineItem ---
export const ItemContainer = styled.div`
  display: flex;
  gap: 16px;
  position: relative;
  padding-bottom: 24px;
`;

export const IconColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 1;

  &::after {
    content: "";
    position: absolute;
    top: 31px;
    bottom: -24px;
    width: 1px;
    background-color: #d1d3d5;
    display: ${props => (props.$isLast ? "none" : "block")};
    z-index: -1;
  }
`;

export const ContentColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 8px;
`;

export const ChangesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ContentHeader = styled.div`
  color: #444;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const SummaryBox = styled.div`
  font-weight: 400;
  font-size: 12px;
`;

// --- HistoryIcon ---
export const IconContainer = styled.div`
  width: 31px;
  height: 31px;
  border-radius: 4px;
  background: #fff;
  box-shadow:
    0 1px 1px 0 rgba(0, 0, 0, 0.1),
    0 0 0 1px rgba(70, 79, 96, 0.16);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const CircleWrapper = styled.div`
  width: 19px;
  height: 19px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #8c8ca1;
`;

// --- UserTimestamp ---
export const UserTimestampContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  flex-wrap: wrap;
`;

export const UserName = styled.span`
  font-weight: 400;
`;

export const TimestampText = styled.span`
  font-weight: 300;
`;

// --- ChangeValue ---
export const ChangeValueContainer = styled.div`
  &.update {
    border-radius: 8px;
    border: 1px solid #e9edf5;
    background: #f9fafd;
    padding: 8px 12px;
    max-width: fit-content;
    font-size: 12px;
  }
`;

export const OldValue = styled.span`
  color: #8c8ca1;
  text-decoration: line-through;
  background: #f4f5f7;
  padding: 2px 6px;
  border-radius: 4px;
`;

export const Arrow = styled.span`
  color: #8c8ca1;
`;

export const NewValue = styled.span`
  font-weight: 600;
`;

export const StyledItemName = styled.span`
  font-weight: 600;
`;

// --- Chips ---
export const ChipRow = styled.div`
  display: flex;
  gap: 8px;
`;

export const Chip = styled.span`
  background: #e9edf5;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 12px;
  color: #464f60;
  font-weight: 500;
`;

export const LinkButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #1249bf;
  font-weight: 500;
  text-decoration: underline;
  font-family: inherit;
  font-size: inherit;

  &:hover {
    color: #0e3a99;
  }
  &:focus {
    outline: 2px solid #1249bf;
    outline-offset: 2px;
  }
`;
